/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_AiInputs */

const en_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const de_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral KI`)
};

const fr_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const es_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const it_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const nl_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const pl_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const fi_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const da_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

const sv_landing_trust_ai = /** @type {(inputs: Landing_Trust_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI`)
};

/**
* | output |
* | --- |
* | "Mistral AI" |
*
* @param {Landing_Trust_AiInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_ai = /** @type {((inputs?: Landing_Trust_AiInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_AiInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_ai(inputs)
	if (locale === "fr") return fr_landing_trust_ai(inputs)
	if (locale === "es") return es_landing_trust_ai(inputs)
	if (locale === "it") return it_landing_trust_ai(inputs)
	if (locale === "nl") return nl_landing_trust_ai(inputs)
	if (locale === "pl") return pl_landing_trust_ai(inputs)
	if (locale === "fi") return fi_landing_trust_ai(inputs)
	if (locale === "da") return da_landing_trust_ai(inputs)
	if (locale === "sv") return sv_landing_trust_ai(inputs)
	return en_landing_trust_ai(inputs)
});